import { render } from "./DocumentLinkContainer.vue?vue&type=template&id=853ef966"
import script from "./DocumentLinkContainer.vue?vue&type=script&lang=js"
export * from "./DocumentLinkContainer.vue?vue&type=script&lang=js"
script.render = render

export default script